import { supabase } from './supabaseClient';

// Récupère les modèles de tâches associés à un type de chantier, triés par
// métier puis par ordre d'affichage. Même requête que l'app mobile.
export async function getTemplatesByType(chantierTypeId) {
  const { data, error } = await supabase
    .from('task_template_types')
    .select(`
      is_required,
      display_order,
      task_templates!inner(
        id,
        title,
        description,
        metier_id,
        created_at,
        metier:metier_id(id, name, icon, color)
      )
    `)
    .eq('chantier_type_id', chantierTypeId)
    .eq('task_templates.is_active', true);

  if (error) throw error;

  return (data || [])
    .map((item) => ({
      ...item.task_templates,
      is_required: item.is_required,
      display_order: item.display_order,
    }))
    .sort((a, b) => {
      if (a.metier_id !== b.metier_id) return a.metier_id - b.metier_id;
      return (a.display_order || 0) - (b.display_order || 0);
    });
}

// Crée les tâches du chantier à partir des modèles sélectionnés, puis
// déclenche (sans bloquer) le calcul de priorité de chacune côté n8n/edge
// function — même logique que TaskTemplateService.generateTasksFromTemplates.
export async function generateTasksFromTemplates(chantierId, userId, templates) {
  const createdTaskIds = [];

  for (const template of templates) {
    const { data: task, error } = await supabase
      .from('chantier_tasks')
      .insert({
        chantier_id: chantierId,
        created_by: userId,
        title: template.title,
        description: template.description,
        metier_id: template.metier_id,
        template_id: template.id,
        status: 'pending',
      })
      .select()
      .single();

    if (error) throw error;
    createdTaskIds.push(task.id);
  }

  createdTaskIds.forEach((taskId) => {
    supabase.functions
      .invoke('compute-task-priority', { body: { task_id: taskId, chantier_id: chantierId } })
      .catch(() => {});
  });
}
